import React from 'react';
import ReactDOM from 'react-dom/client';
import { EventType, PublicClientApplication } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import './index.css';
import App from './App';
import { msalConfig } from './authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

const rootElement = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(rootElement);

function renderApp() {
  root.render(
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );
}

async function bootstrapMsal(): Promise<void> {
  await msalInstance.initialize();

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS || event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
      const payload = event.payload as { account?: unknown } | null;
      if (payload?.account) {
        msalInstance.setActiveAccount(payload.account as Parameters<typeof msalInstance.setActiveAccount>[0]);
      }
      sessionStorage.removeItem('MSAL_LAST_ERROR');
    }

    if (event.eventType === EventType.LOGOUT_FAILURE || event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
      const message = event.error?.message || 'Microsoft sign-in failed.';
      sessionStorage.setItem('MSAL_LAST_ERROR', message);
      console.error('[auth] MSAL error:', message);
    }
  });

  try {
    const response = await msalInstance.handleRedirectPromise();
    if (response?.account) {
      msalInstance.setActiveAccount(response.account);
    } else {
      const accounts = msalInstance.getAllAccounts();
      if (accounts.length === 1) {
        msalInstance.setActiveAccount(accounts[0]);
      }
    }
  } catch (err) {
    const message = err instanceof Error ? err.message : 'Microsoft sign-in redirect failed.';
    sessionStorage.setItem('MSAL_LAST_ERROR', message);
    console.error('[auth] Redirect handling failed:', message);
  }
}

bootstrapMsal().finally(() => {
  renderApp();
});
